module.exports = __webpack_public_path__ + "img/product2.77917eb4.jpg";